import axios from "axios";
import * as actionType from "../../../constant/actionType";

export const WaiveWorkerDoc = (apiData) => async () => {
  try {
    const response = await axios({
      method: "post",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
      },
      url: `${actionType.environment_url}/api/admin/provider/WaiveWorkerDoc`,
      data: apiData,
    });
    return response.data;
  } catch (error) {
    return error?.response?.data || { success: false, message: error.message };
  }
};
